import { Outlet, ScrollRestoration, createRootRoute } from '@tanstack/react-router';
import { Header } from '../components/Header.js';
import { Footer } from '../components/Footer.js';

export const Route = createRootRoute({
  component: () => (
    <div className="flex min-h-dvh flex-col">
      <ScrollRestoration />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  ),
});
